// German overrides for portfolio items, keyed by slug.
// `localizeItem(item, lang, PORTFOLIO_DE)` merges these onto the English item,
// falling back to English for any field that isn't present here — so partial
// translation never breaks rendering. Proper nouns (client names, cities,
// artist names, product names, event names) stay in English.

export const PORTFOLIO_DE = {
  'dubai-booth-websummit': {
    title: 'Dubai-Stand @ WebSummit',
  },
  'axel-springer-hy-web3-summit': {
    title: 'Axel Springer/HY Summit-Reihe',
  },
  'waves-audio-live-campaigns': {
    title: 'Waves Audio Europakampagnen',
    campaign: {
      role: 'Großteil der europäischen Kampagneninhalte gefilmt und geschnitten',
      intro:
        "Ich war schon immer ein riesiger Musikfan, und als Waves mich anfragte, ob ich für sie filme, habe ich sofort zugesagt. Von Künstler:innen, die ich selbst wirklich höre, bis zu solchen, die auf Welttournee in Stadien stehen — es ist eine Freude, bei jedem davon dabei zu sein. Wir filmen seit 2025 und 2026 die europäischen Etappen der LV1-Classic- und Livebox-Launches von Waves. Vier Städte, Behind-the-Scenes-Filme, die Konsolen im echten Touring-Einsatz mit den Engineer:innen, die sie tatsächlich bedienen. Jede Show läuft gleich ab. Eine Chance, keine Wiederholungen. Ein:e FOH-Engineer:in mitten im Set kann nicht anhalten, um Sie zu dirigieren, und eine Live-Konsole wartet nicht, bis Sie aufgebaut haben. Also arbeiten wir um die Arbeitsfläche herum, bleiben aus dem Mix heraus und liefern Waves Footage, das sie für die Kampagne wirklich verwenden können. Was Sie nicht sehen, ist der Rest. Trunkenen Mengen ausweichen, gelegentlich eine Schlägerei, die an der Linse vorbeidriftet, Security, die sich mitten im Schuss durchs Bild drängt. Bands, Manager:innen und Egos manövrieren, die innerhalb einer Stunde von „keine Kameras“ zu „wir wollen mehr Shots von dem/der Künstler:in!“ kippen. Die meisten glauben nicht die Hälfte davon, was in zwei saubere Minuten Konsolen-Footage bei einem ausverkauften Konzert fließt. Also bewegen wir uns leise, filmen schnell und bleiben auf der guten Seite aller, die uns stoppen könnten.",
      outcome:
        "Launch der LV1-Classic-Konsole und von Waves Livebox über die Marketing-Kanäle von Waves.",
      editCredits:
        "Weitere Schnitte für Waves: der LV1-80-Kanal-Update-Launchfilm mit Ken „Pooch“ Van Druten, das Video mit Kevin „Tater“ McCarthy, Lu Diaz’ „6 Mixing Mistakes“ (Jay Z, Beyoncé) und ein zweiter Pitbull-/Will-Madera-LV1-Classic-Film.",
      products: [
        {
          shoots: [
            {}, // Pitbull — engineer/city are proper-noun strings, keep English
            {}, // Ken 'Pooch' Van Druten
            {}, // Andrew Peters
            {}, // Don Toliver
          ],
        },
      ],
    },
  },
  'hy-summits': {
    title: 'HY — Summits & Innovation Sessions',
    campaign: {
      role: 'Dreh + Schnitt',
      years: 'Seit Mai 2017',
      intro:
        "Ich filme seit Mai 2017 für HY. Angefangen hat es mit ihren Innovation-Kursen, bei denen Audi-Führungskräfte nach Berlin kamen, um Startups zu treffen, danach ein Highlight-Film für Helaba. In den letzten fünf Jahren besteht die Arbeit aber hauptsächlich aus ihren Summits. Was früher ein einziger Summit war, wurde irgendwann zu dreien: Innovation, Web3 und Pricing. Hochkarätige Meetings wirken vor der Kamera nicht von sich aus aufregend. Ein Raum voller Führungskräfte, die reden, ist eben ein Raum voller Führungskräfte, die reden. Die Aufgabe ist es, die Energie zu finden, die tatsächlich im Raum ist, und sie aufs Bild zu bringen — mit Pacing, Kameraführung und einem Schnitt, der dem Ernst des Gesprächs entspricht, ohne es zu einer flachen Werner-Vereinfachung zu machen.",
      products: [
        {
          shoots: [
            {
              character:
                'Auf Wunsch kantig. Punchigere Schnitte, mehr Attitüde, gemacht für einen Raum, der pitchen muss.',
            },
            {
              character: 'Volle Fahrt. Dichte Speaker-Stacks, Split Screens.',
            },
            {
              character:
                'Der ruhigste der drei. Ein zurückhaltender Schnitt für einen gemessenen, analytischen Raum.',
            },
          ],
        },
      ],
    },
  },
  'kenes-group-brand': {
    title: 'Kenes Group — Markenfilm',
  },
  'ests-2026-promo': {
    title: 'ESTS 2026 — Promo',
  },
  'attd-2026': {
    title: 'ATTD 2026 — Highlight-Video',
  },
  'kenes-group-recruitment': {
    title: 'Kenes Group — Recruiting-Video',
  },
  'cylus-fireside-chat-innotrans-berlin': {
    title: 'Cylus — Fireside Chat · InnoTrans Berlin',
  },
  'media-pioneer': {
    title: 'Media Pioneer',
  },
  'g4i-2026-promo': {
    title: 'G4I 2026 — Promo',
  },
  'pioneer-media-commerzbank': {
    title: 'Pioneer Media — Commerzbank-Event',
  },
  'adpd-2026-highlights': {
    title: 'AD/PD 2026 — Highlight-Reel',
  },
  'espghan-2025': {
    title: 'ESPGHAN 2025',
  },
  'attd-2025': {
    title: 'ATTD 2025 — Highlight-Video',
  },
  'espghan-2023': {
    title: 'ESPGHAN 2023',
  },
  'adpd-2026-day2': {
    title: 'AD/PD 2026 — Tag-2-Highlight-Video',
  },
  'adpd-2026-day1': {
    title: 'AD/PD 2026 — Tag-1-Reel',
  },
  'espghan-2026-highlights': {
    title: 'ESPGHAN 2026 — Highlights',
  },
  'wsava-2026-promo': {
    title: 'WSAVA 2026 — Promo',
  },
  'simul-europe': {
    title: 'Simul Europe — Wirtschaftskonferenz, Griechenland',
  },
  'dubai-booth-london-tech-week': {
    title: 'Dubai-Stand @ London Tech Week',
  },
  'ravendb-wearedevelopers-berlin': {
    title: 'RavenDB @ WeAreDevelopers Berlin',
  },
  'meta-dmexco': {
    title: 'Meta @ DMEXCO',
  },
  'roborock-ifa-berlin': {
    title: 'ROBOROCK — IFA Berlin',
  },
  'stepac-fruit-logistica-berlin': {
    title: 'STEpac — Fruit Logistica, Berlin',
  },
  'cornelsen-innovation-awards': {
    title: 'Cornelsen Innovationspreis-Clips',
    campaign: {
      role: 'Dreh + Schnitt',
      years: 'Fortlaufend',
      intro:
        "Die Kunst besteht nicht darin, eine Schule zu filmen. Sondern darin, dass eine Schule einen an der Stelle filmen lässt, die wirklich zählt. Wir filmen seit mehreren Jahren die Gewinner-Filme für zwei Cornelsen-Schulpreise: den Zukunftspreis, der innovative Unterricht und Schulführung auszeichnet, und fair@school, einen Preis zusammen mit der Antidiskriminierungsstelle des Bundes für Schulprojekte, die sich für Vielfalt und gegen Diskriminierung einsetzen. Jeder Film zeigt eine Schule, die etwas wirklich Neues macht, und die Aufgabe ist es, den Ort zu zeigen und in wenigen Minuten zu erklären, was ihn auszeichenswert macht. Das ist ein anderes Briefing als ein Kongress-Highlight-Reel. Weniger Pacing, mehr Story. Man fängt nicht die Energie eines Raumes ein, sondern den Geist eines Ortes und der Menschen, die ihn anders gemacht haben. Das Schwierige ist selten das Filmen. Es ist, das Vertrauen von Kindern zu verdienen, die nicht vor die Kamera wollen oder sich nicht richtig interviewen lassen wollen. Manchmal liegt der Grund für den Preis leise verborgen — eine kleine Gruppe Kinder, die etwas probiert, das die breitere Gemeinschaft noch nicht eingeholt hat — und der Film muss das ehren, ohne jemanden bloßzustellen. Manchmal ist es ein sensibles Thema, das so unterrichtet wird, dass es keine Seite ergreift, aber auch nicht tut, als gäbe es das nicht — etwa wie man Kindern den Krieg erklärt.",
      products: [
        {
          shoots: [
            { artist: 'Schule in Radibor' },
            { artist: 'Schule in Waren' },
            { artist: 'Schule in Hannover' },
            { artist: 'Schule in Solingen' },
            { artist: 'Schule in Rangsdorf' },
          ],
        },
        {
          shoots: [
            { artist: 'Schule in Spremberg' },
            { artist: 'Schule in Scharnebeck' },
            { artist: 'Schule in Neuss' },
          ],
        },
      ],
    },
  },
};
